module.exports = __webpack_public_path__ + "img/icon-3-1.6ac4538f.png";